import data from "../../../../src/pages/topic/video-games/nintendo-switch-online/data.yaml";
import * as React from 'react';
export default {
  data,
  React
};